<template>
    <div ref="cardDetailRef" class="image">
        <div class="image-title">
            {{ image.name }}
            <el-tooltip class="item" effect="dark" content="已签约独家，作品仅数字像素售卖" placement="top">
                <div class="image-exclusive" v-show="image.exclusive === 0">独家</div>
            </el-tooltip>
        </div>
        <div class="image-detail">
            <el-card class="image-content-card main-detail" shadow="never">
                <div class="detail-wrap">
                    <div class="detail-content" :class="imageRatio" @click="handleImage(0)">
                        <img :src="`${image.url}`" alt="" ref="logoImage" @load="checkImageRatio">
                    </div>
                </div>
            </el-card>
            <div style="width: 385px">
                <el-card class="image-content-card image-info" shadow="never" v-if="image.id">
                    <div class="image-info-addition">
                        <div class="image-info-addition-item">
                            <span v-if="image.price">
                                <!-- <span v-if="isPaid" class="image-info-price-tag paid"
									>已购买</span
								> -->
                                <!-- <span v-else class="image-info-price-tag needPay">付费</span> -->
                                <span class="image-info-price-tag price">{{ image.price }}<i class="price-unit">元</i></span>
                                <span class="image-info-price-tag origin-price" v-if="image.scribingPrice">
                                    {{ image.scribingPrice }}<i class="price-unit">元</i>
                                </span>
                            </span>
                            <span v-else class="image-info-price-tag free">免费</span>
                        </div>
                        <div class="image-info-addition-item" style="justify-content: flex-end">
                            <!-- <span style="color: #999">{{ image.downloads }}次下载</span> -->
                            <span style="color: #999"></span>
                        </div>
                        <div class="image-info-addition-item" style="justify-content: flex-end">
                            <span :class="isCollect ? 'collected-con' : 'collect-con'" @click="handleCollect">
                                <svg-icon icon-class="collected" :class-name="isCollect ? 'collected' : 'icon-collect-btn'"></svg-icon>
                                {{ isCollect ? `${image.collections || 0}人已收藏` : '未收藏' }}</span
                            >
                            <!-- <span class="share"><img src="@/assets/images/share.png" alt="分享" class="share-img">分享</span> -->
                        </div>
                    </div>
					<div class="image-info-addition" v-if="(image.price && !userInfo) || (image.memberLevel === 'F' && image.price > 0)">
						<!-- <div class="img-vip-tip-wrap">
							<span class="img-vip-tip">会员免费下载</span>
							<b class="img-vip-btn" @click="toVip">成为会员</b>
						</div> -->
					</div>
                    <div class="vip-times" v-if="image.memberLevel !== 'F' && userInfo && image.price > 0">
                        <div v-if="userInfo.remainTimes !==0" class="active">今日会员剩余下载{{ userInfo.remainTimes }}次</div>
                        <div v-else class="de-active">今日会员下载次数已用完，明天再来哦</div>
                    </div>
                    <template>
                        <div class="image-info-detail">
                            <!-- <div class="image-info-detail-desc">{{ image.remark }}</div> -->
                            <!-- <el-divider></el-divider> -->
                            <div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-no.png" alt=""> -->
                                编号：<label>{{ image.serialCode }}</label>
                            </div>
                            <div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-author.png" alt=""> -->
                                作者：<label >{{
                                    image.author
                                }}</label>
								<!-- <label class="author" title="点击可查看该作者所有图片" @click="toAuthor(image.author)">{{
                                    image.author
                                }}</label> -->
                            </div>
                            <div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-category.png" alt=""> -->
                                分类：<label>{{ image.categoryList | filterName(' / ') }}</label>
                            </div>
                            <div v-if="image.size" class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-size.png" alt=""> -->
                                尺寸：<label>{{ image.size || '1233*23444px' }}</label>
                            </div>
                            <div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-type.png" alt=""> -->
                                格式：<label>{{ image.formatList | filterName(' / ') }}</label>
                            </div>
                            <div class="detail-info-item" v-if="image.versionRecommend">
                                <!-- <img src="../../../assets/images/icon-version.png" alt=""> -->
                                版本推荐：<label>{{ image.versionRecommend }}</label>
                            </div>
                            <div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-file-size.png" alt=""> -->
                                体积：<label>{{ image.fileSize || '0kb' }}</label>
                            </div>
                            <div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-date.png" alt=""> -->
                                上传时间：<label>{{ image.publishDate }}</label>
                            </div>
							<div class="detail-info-item">
                                <!-- <img src="../../../assets/images/icon-date.png" alt=""> -->
                                版权：<label>{{ image.copyright }}</label>
                            </div>
                        </div>
                        <div v-if="image.price && !isPaid && (image.memberLevel == 'F' || !image.memberLevel)">
                            <el-button class="pay-btn" :class="{ disabled: buttonDisabled }" type="primary" block @click="toPay">
                                <!-- <img
									src="@/assets/images/pay.png"
									alt="购买"
									class="download-btn-img"
								/> -->
                                <span style="vertical-align: top">&nbsp;{{ !buttonDisabled ? '立即下载' : '暂不支持购买' }}</span>
                            </el-button>
                            <div class="ques-text" style="margin-top: 5px">下载方式为百度网盘，购买后自动获取网盘链接</div>
                        </div>
                        <template v-else-if="(image.price && isPaid) || image.memberLevel !== 'F' || image.price == 0">
                            <!-- <div class="baidu-code">网盘提取码：{{ (image.baiduUrl || '').slice(-4) }}</div> -->
                            <el-button :class="'download-btn baidu'" type="primary" @click="handleDownLoad()">
                                <img src="@/assets/images/baidu.png" alt="下载" class="download-btn-img" />
                                <span style="vertical-align: top">&nbsp;百度网盘下载</span>
                            </el-button>
                            <el-button class="download-btn local" :loading="isLocaleDownLoading" v-if="image.source" @click="handleDownLoad">
                                <img src="@/assets/images/local.png" alt="下载" class="download-btn-img" />
                                <span style="vertical-align: top">&nbsp;本地下载</span>
                            </el-button>
                            <div class="download-question">
                                如遇下载问题，请<span @mouseenter="showPop('showContract', true)" @mouseleave="showPop('showContract', false)"
                                    >点此联系</span
                                >
                                <div class="service-modal" v-show="showContract">
                                    <img src="../../../assets/images/contract.png" alt="" />
                                    <div>
                                        <div class="service-modal-tit">图片下载遇到问题，请加企业微信</div>
                                        <div class="service-modal-info">购买图片后，下载失败、网盘下载不便，请添加企业微信，我将及时为你解决</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <div class="authorized" v-if="image.price">
                        <div class="authorized-tit">
                            <span>商用授权范围</span>
                            <div class="authorized-right">
                                <template v-if="image.price && !isPaid">
                                    <span
                                        class="authorized-active-default"
                                        @mouseenter="showPop('showAuthorized', true)"
                                        @mouseleave="showPop('showAuthorized', false)"
                                        >其他咨询</span
                                    >
                                </template>
                            </div>
                            <div class="service-modal" v-show="showAuthorized">
                                <img src="../../../assets/images/contract.png" alt="" />
                                <div>
                                    <div class="service-modal-tit">有问题，请加企业微信</div>
                                    <div class="service-modal-info">咨询素材、授权书、发票相关问题，请添加企业微信，我将及时为你服务</div>
                                </div>
                            </div>
                        </div>
                        <div class="authorized-item" v-for="item in authorizedList[1]" :key="item.id">
                            <img src="../../../assets/images/auth-pass.svg" v-if="item.selected === 0" alt="" />
                            <img src="../../../assets/images/auth-reject.svg" v-else alt="" />
                            <div class="authorized-item-text" :title="item.content">
                                {{ item.content }}
                            </div>
                        </div>
                    </div>
                    <div class="bottom-info">
                        使用限制：供稿人仅对作品中独创性部分享有权利。对含有的国旗、国徽等党政图案不享有权利，地图数据不享有权利，仅作为作品整体效果的示例展示及爱党爱国宣传，禁止商用。
                    </div>
                </el-card>
            </div>
        </div>

        <img-dialog-show
            ref="imgDialog"
            :img-dialog-show.sync="imgDialogShow"
            @closeOrg="imgDialogShow = false"
            :img-url-arr="pictureList"
            :img-index="index"
        />

        <div class="pay-modal" v-if="showPayWay">
            <div class="pay-modal-con">
                <img class="modal-close" @click="closePayModal" src="../../../assets/images/close.png" alt="" />
                <div class="modal-tit">{{ payType | getPayTitle }}</div>
                <div class="pay-con" v-if="!payType">
                    <div class="pay-icon" @click="handleClickPay('wechat')">
                        <img src="../../../assets/images/wechat_pay.png" alt="" />
                        <div>微信支付</div>
                    </div>
                    <div class="pay-icon alipay" @click="handleClickPay('alipay')">
                        <img src="../../../assets/images/ali_pay.png" alt="" />
                        <div>支付宝支付</div>
                    </div>
                    <div class="pay-icon common" @click="handleClickPay('common')">
                        <img src="../../../assets/images/common.png" alt="" />
                        <div>对公支付</div>
                    </div>
                </div>
                <div class="pay-qr" v-else>
                    <img :src="payUrl" alt="" />
                </div>
            </div>
        </div>
        <auth-table :visible.sync="showAuthTable" :tableData="authTable" showPlus />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import debounce from 'lodash/debounce';
import ImgDialogShow from '@/components/ImgDialogShow';
import AuthTable from '@/views/components/AuthTable';
import { openWindow } from '@/utils/utils';
import moment from 'moment';
import { collectImage, cancelCollectImage, getImageDetail, getDownloadUrl } from '@/api/findImage/index.js';
import { getAuthorizedList } from '@/api/material/index.js';
import { getPayUrl, getStatus } from '@/api/order';

export default {
    inject: ['checkToken'],
    directives: { Clickoutside },
    components: {
        ImgDialogShow,
        AuthTable,
    },
    filters: {
        filterName(list, format) {
            return (list || []).map((item) => (item||{}).name).join(format);
        },
        getPayTitle(payType) {
            let patTitle = '请选择支付方式';
            if (payType == 'wechat') {
                patTitle = '请使用微信支付';
            }
            if (payType == 'alipay') {
                patTitle = '请使用支付宝支付';
            }
            if (payType == 'common') {
                patTitle = '对公支付请添加企微对接';
            }
            return patTitle;
        },
    },
    data() {
        return {
            payType: '',
            activeTab: 0,
            showPayWay: false,
            showContract: false,
            showAuthorized: false,
            showMorePayWay: false,
            showAuthTable: false,
            authTable: [],
            authorizedList: {
                0: [],
                1: [],
                2: [],
            },
            left: 1,
            collectMethod: collectImage,
            cancelCollectMethod: cancelCollectImage,
            isCollect: false,
            isDownLoading: false,
            payUrl: null,
            image: {},
            imgDialogShow: false,
            index: 0,
            pictureList: [],
            isLocaleDownLoading: false,
            imageRatio: 'vertical', // 默认为垂直方向
        };
    },
    computed: {
        ...mapState('user', ['userInfo']),
        buttonDisabled() {
            return false
        },
        isPaid() {
            let isPaid = this.image.buyState === 1;

            return isPaid;
        },
    },
    watch: {
        image: {
            immediate: true,
            handler(newVal) {
                this.isVisible = newVal !== null;
                if (newVal) {
                    this.isCollect = newVal.collection === 1;
                    newVal.left !== undefined && (this.left = newVal.left);
                }
            },
        },
        'image.url': {
            handler() {
                this.$nextTick(() => {
                    this.checkImageRatio();
                });
            }
        },
        isVisible() {
            if (this.isVisible) {
                this.$nextTick(() => {
                    this.$refs.cardDetailRef && (this.$refs.cardDetailRef.oncontextmenu = () => false);
                });
            }
        },
    },
    created() {
        this.getDetail();
    },
    mounted() {
        this.$nextTick(() => {
            this.checkImageRatio();
        });
    },
    methods: {
        checkImageRatio() {
            const img = this.$refs.logoImage;
            if (!img) return;
            
            // 如果图片已经加载完成
            if (img.complete) {
                this.setImageRatio(img);
            } else {
                // 图片未加载完成，添加加载事件
                img.onload = () => {
                    this.setImageRatio(img);
                };
            }
        },
        
        setImageRatio(img) {
            if (img.naturalWidth > img.naturalHeight) {
                this.imageRatio = 'horizontal';
                if(img.naturalHeight < 100) {
                    this.imageRatio = 'square';
                }
            }else{
                this.imageRatio = 'vertical';
            }
        },
        
        toPay() {
            if (this.buttonDisabled) return;
            if (!this.checkToken()) return;
            this.showPayWay = true;
        },
		toVip() {
			this.$router.push({ name: 'FindImageVip' });
		},
        handleImage(i) {
            this.imgDialogShow = true;
            this.index = i;
            this.$nextTick(() => {
                this.$refs.imgDialog.handleClickImgOrg();
            });
        },
        bindImage() {
            this.pictureList = [{
                address: this.image.url,
            }]
        },
        async getDetail() {
            try {
                const { data: image } = await getImageDetail(this.$route.params.id);
                image.publishDate = image.publishDate ? moment(image.publishDate).format('YYYY-MM-DD') : '-';
                this.image = image;
                window.document.title = this.image.name;
                console.log('imageInfo', image);
                this.$nextTick(() => {
                    this.bindImage();
                });
                this.getAuthorizedList();
            } catch (error) {
                console.log('error: ', error);
            }
        },
        async getAuthorizedList() {
            try {
                const { data } = await getAuthorizedList();
                this.authorizedList = data;
                console.log('data: ', data);
                const objKey = {};
                this.authTable = [];
                const last_person_index = data['0'].length - 1;
                Object.values(data || {})
                    .flat()
                    .forEach((item) => {
                        if (!objKey[item.content]) {
                            this.authTable.push({
                                content: item.content,
                                selected: {
                                    [item.type]: item.selected,
                                },
                            });
                        } else {
                            const index = this.authTable.findIndex((subItem) => subItem.content === item.content);
                            this.authTable[index].selected[item.type] = item.selected;
                        }
                        objKey[item.content] = item.content;
                    });
                const last_table_index = this.authTable.length - 1;
                this.authTable.splice(last_table_index, 0, this.authTable.splice(last_person_index, 1)[0]);
            } catch (error) {
                console.log('error: ', error);
            }
        },
        showPop(name, value) {
            this.showAuthorized = false;
            this.showContract = false;
            this.showMorePayWay = false;
            this[name] = value;
        },
        openAuthImg() {
            const imgUrl =
                this.activeTab === 0
                    ? '/static/images/person.png'
                    : this.activeTab === 1
                    ? '/static/images/company.png'
                    : '/static/images/company-plus.png';
            window.open(imgUrl);
        },
        handleCollect: debounce(function () {
            if (!this.checkToken()) return;
            this[this.isCollect ? 'cancelCollectMethod' : 'collectMethod'](this.image.id).then(() => {
                this.$message.success(this.isCollect ? '已取消收藏' : '收藏成功');
                const collections = this.isCollect ? this.image.collections-1 : this.image.collections+1;
                console.log('collections: ', collections);
                this.$set(this.image, 'collections', collections);
                this.isCollect = !this.isCollect;
                this.image.isCollected = this.isCollected;
            });
        }, 300),
        handleDownLoad(type) {
			console.log('type: ', type);
            if (!this.userInfo) {
                this.$router.push({ name: 'Login' });
                return;
            }
            if (this.isLocaleDownLoading) {
                this.$message.warning('正在下载哦，不要心急');
                return;
            }
            this.isLocaleDownLoading = true;
            getDownloadUrl(this.image.id)
                .then((res) => {
                    this.$store.dispatch('user/getUserInfo')
                    window.open(res.data.baiduUrl);
                })
                .catch(() => {
                    this.$message.error('下载失败，请稍后再试');
                }).finally(() => {
                    this.isLocaleDownLoading = false;
                });
        },
        closePayModal() {
            if (this.payUrl) {
                this.payUrl = '';
                this.payType = '';
            } else {
                this.showPayWay = false;
            }
        },
        handleClickPay(payType) {
            if (payType === 'common') {
                this.payType = payType;
                this.payUrl = '/static/images/company_wechat.png';
                return;
            }
            getPayUrl({
                type: 4,
                goodsId: this.image.id,
                payType,
            })
                .then((res) => {
					this.payType = payType;
                    this.payUrl = res.data.data;
                    this.getPayResult(res.data.orderId);
                })
                .catch(() => {
                    this.payUrl = '';
                });
        },
        getPayResult(id) {
            const paidName = 'buyState';
            getStatus(id).then((res) => {
                const { data } = res;
                if (data.code === 1) {
                    this.payUrl = '';
                    this.image[paidName] = 1;
                    this.showPayWay = false;
                    this.getDetail();
                } else if (data.code === 2) {
                    setTimeout(() => {
                        this.getPayResult(id);
                    }, 2e3);
                } else if (data.code === 3) {
                    this.payUrl = '';
                    this.image[paidName] = 1;
                    this.showPayWay = false;
                    this.getDetail();
                } else {
                    this.payUrl = '';
                    this.showPayWay = false;
                    this.$message.error('付款失败，' + data.msg);
                }
            });
        },
        setImage(image) {
            if (!image.id) {
                return;
            }
            openWindow(`/#/image/detail/${image.id}`);
        },
        toAuthor(authorName) {
            if (!authorName) {
                return;
            }
            openWindow(`/#/image/author/${authorName}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.image {
    width: 100%;
    min-height: 100%;
    overflow-y: auto;
    position: relative;
    .image-title {
        width: 1285px;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        padding: 40px 0 24px;
        margin: 0 auto;
        .image-exclusive {
            margin-left: 16px;
            padding: 2px 10px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #000000;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
            cursor: pointer;
        }
    }
    .image-detail {
        width: 100%;
        min-height: 600px;
        overflow-y: auto;
        display: flex;
        justify-content: center;
        position: relative;
		padding-bottom: 20px;
    }
    .bottom {
        width: 1285px;
        margin: 0 auto;
    }
    .image-content-card {
        border: 0;
		background-color: transparent;
    }
    .main-detail {
        width: 880px;
        margin-right: 20px;
        padding: 0;
        border-radius: 10px;
        /deep/ .el-card__body {
            padding: 0;
            .detail-wrap {
                margin: 0 auto;
                border-radius: 10px;
                // background-color: #fff;
            }
            .detail-head {
                padding: 0 0 10px 0;
                border-bottom: 1px solid #ecedff;
                &__title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: #272c40;
                    font-size: 22px;
                    font-weight: 600;
                }

                &__extra {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .tag {
                        margin: 10px 0;
                        &-item {
                            margin: 10px 10px 0 0;
                            padding: 3px 10px;
                            background: rgba(47, 84, 235, 0.1);
                            border-radius: 12px;
                            font-size: 12px;
                            color: #2f54eb;
                            cursor: pointer;
                        }
                    }
                    .time {
                        font-size: 14px;
                        color: #a8adc1;
                    }
                }
            }
            .detail-content {
                display: flex;
                justify-content: center;
                align-items: center;
                // padding: 20px;
                background-image: linear-gradient(to top right, #d4d4d4 25%, transparent 0, transparent 75%, #d4d4d4 0, #d4d4d4), linear-gradient(to top right, #d4d4d4 25%, transparent 0, transparent 75%, #d4d4d4 0, #d4d4d4);
                background-color: #dfdfdf;
                background-size: 16px 16px;
                background-position: 0 0, 8px 8px;
                cursor: url('../../../assets/images/zoom-in-line.png'), auto;
                
                /* 垂直图片样式 - 高大于宽 */
                &.vertical {
                    width: 100%;
                    border-radius: 8px;
                    border: 1px solid #DBE0F4;
                    img {
                        max-width: 100%;
                        max-height: 600px; /* 限制最大高度 */
                        border-radius: 0;
                    }
                }
                
                /* 水平图片样式 - 宽大于高 */
                &.horizontal {
                    width: 100%;
                    img {
                        width: 100%;
                    }
                }
                &.square {
                    width: 100%;
                    height: 880px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 8px;
                    border: 1px solid #DBE0F4;
                    img {
                        width: 100%;
                        border-radius: 0;
                    }
                }
                

                img {
                    vertical-align: middle;
                    display: block;
					border-radius: 8px;
                }

                .ql-align-center {
                    margin: 0;
                    padding: 0;
                }
            }
            .mode {
                padding: 3px;
                background: rgba(0, 0, 0, 0.05);
                width: 100px;
                height: 36px;
                span {
                    display: inline-block;
                    border-radius: 2px;
                    width: 50%;
                    height: 30px;
                    text-align: center;
                }
                .active {
                    background-color: #fff;
                }
                img {
                    position: relative;
                    top: -2px;
                    width: 30px;
                    vertical-align: bottom;
                    cursor: pointer;
                }
            }
        }
    }

    .image-info {
        min-width: 300px;
        width: 385px;
        vertical-align: top;
        text-align: left;
        background: inherit;
        overflow: visible;

        & /deep/ .el-card__body {
            text-align: left;
            background: #fff;
            border-radius: 10px;

            .image-info-tab {
                margin-bottom: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .image-info-tab-item {
                    flex: 1;
                    margin-right: 3px;
                    border-radius: 4px;
                    background: #fafafa;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #555555;
                    font-size: 14px;
                    height: 40px;
                    cursor: pointer;
                    font-weight: 400;
                    box-sizing: border-box;
                    &:hover {
                        background: #e8e8e8;
                    }
                    &.active {
                        background: #f5f6f9;
                        color: #2f54eb;
                        border: 1px solid #2f54eb;
                    }
                    &:nth-last-child(1) {
                        margin-right: 0;
                    }
                }
            }
            .image-info-name {
                font-size: 20px;
                font-weight: 600;
                display: flex;
                .title {
                    flex: 1;
                }
                .exclusive {
                    margin-right: 6px;
                    width: 37px;
                    height: 21px;
                    background: #eb793c;
                    border-radius: 4px 4px 4px 4px;
                    line-height: 21px;
                    text-align: center;
                    color: #fff;
                    font-size: 12px;
                    position: relative;
                    top: 5px;
                }
            }
            .image-info-addition {
                display: flex;
                justify-content: space-between;
                &-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 12px;
                    & > span {
                        display: flex;
                        align-items: center;
                    }
                    .image-info-price-tag {
                        &.free {
                            color: #3cd19f;
                            font-size: 22px;
                        }
                        &.needPay,
                        &.paid {
                            padding: 2px 10px;
                            border-radius: 4px;
                            color: #fff;
                            font-weight: 600;
                        }
                        &.needPay {
                            background-color: #eb793c;
                            font-weight: 600;
                        }
                        &.price {
                            color: #0c0c0e;
                            font-size: 22px;
                            font-weight: 600;
                            .price-unit {
                                font-style: normal;
                                color: #0c0c0e;
                                font-size: 12px;
                                font-weight: 400;
                            }
                        }
                        &.origin-price {
                            color: #999;
                            font-size: 16px;
                            font-weight: 400;
                            margin-left: 10px;
                            text-decoration-line: line-through;
                        }

                        &.paid {
                            border: 1px solid #eb793c;
                            color: #eb793c;
                            font-weight: 600;
                        }
                    }
                }
				.img-vip-tip-wrap {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					margin-top: 10px;
					.img-vip-tip {
						font-weight: 400;
						font-size: 14px;
						color: #FF832A;
						margin-right: 10px;
					}
					.img-vip-btn {
						border-radius: 4px 4px 4px 4px;
						border: 1px solid #FF832A;
						font-weight: 400;
						font-size: 14px;
						color: #FF832A;
						padding: 2px 10px;
						cursor: pointer;
						&:hover {
							background: #FF832A;
							color: #fff;
						}
					}
				}
            }

            .vip-times {
                margin: 10px 0;
                font-weight: 400;
                font-size: 14px;
                .active {
                    color: #1ACCB4;
                }
                .de-active {
                    color: #999999;
                }
            }

            .image-info-detail-tagInfo {
                margin-top: 11%;
                .el-divider {
                    margin: 24px auto;
                    background-color: #ccc;
                    width: 50%;
                    height: 2px;
                    border-radius: 3px;

                    .el-divider__text {
                        padding: 0 10px;
                        width: fit-content;
                        color: #999;
                        font-size: 16px;
                    }
                }
            }
            .image-info-detail-payWay {
                margin-bottom: 10px;
                .pay-tit {
                    text-align: center;
                    color: #272c40;
                    font-weight: 600;
                    font-size: 20px;
                    margin: 40px 0;
                }
                .pay-con {
                    display: flex;
                    padding: 0 34px;
                    justify-content: space-between;
                    .pay-item {
                        cursor: pointer;
                        display: flex;
                        width: 130px;
                        height: 115px;
                        background: #eaffea;
                        border: 1px solid #09bb07;
                        border-radius: 6px;
                        justify-content: flex-end;
                        align-items: center;
                        flex-direction: column;
                        padding-bottom: 18px;
                        color: #333333;
                        font-size: 16px;
                        font-weight: 600;
                        &:nth-child(2) {
                            background: #f7faff;
                            border: 1px solid #1677ff;
                            .pay-icon {
                                width: 50px;
                                margin-bottom: 9px;
                            }
                        }
                        .pay-icon {
                            width: 43px;
                            margin-bottom: 16px;
                        }
                    }
                }
                .pay-tip {
                    color: #999999;
                    font-size: 12px;
                    padding: 0 20px;
                    line-height: 20px;
                    text-align: center;
                    margin-top: 40px;
                    position: relative;
                    .more-pay-way {
                        color: #2c54ef;
                        cursor: pointer;
                        &:hover {
                            color: #5b7dff;
                        }
                    }
                }
            }
        }
        .image-info-detail {
            margin: 3% 0;
            color: #999999;
            line-height: 2;
            font-size: 14px;

            .detail-info-item {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                label {
                    color: #333;
                    flex: 1;
                }
                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                    position: relative;
                    top: 7px;
                }

                .author {
                    cursor: pointer;
                    color: #2c54ef;
                    &:hover {
                        color: #5b7dff;
                    }
                }
            }
        }
        .pay-content {
            display: flex;
            align-items: center;
            flex-direction: column;
            .pay-tips {
                margin-top: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #09bb07;
                font-size: 18px;
                img {
                    padding-right: 10px;
                }
                &.ali {
                    color: #1677ff;
                }
            }
            .image-image {
                width: 200px;
                height: 200px;
            }
            .more-pay-way {
                color: #8c8c8c;
                font-size: 16px;
                cursor: pointer;
                margin-top: 10px;
            }
        }
        .download-btn,
        .pay-btn {
            width: 100%;
            font-size: 20px;
            line-height: 1.5;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
            /deep/ span {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            &-img {
                margin-right: 4px;
                width: 26px;
                vertical-align: middle;
            }
        }
        .baidu-code {
            font-size: 14px;
            font-weight: 400;
            color: #272c40;
            margin: 10px 0;
        }
        .local {
            width: 345px;
            height: 54px;
            background: #ffffff;
            border-radius: 50px;
            opacity: 1;
            border: 1px solid #27c2ff;
            color: #27c2ff;
            margin-left: 0;
            margin-top: 20px;
            &:hover {
                background: #f0fbff;
            }
        }
        .download-question {
            color: #aaa;
            font-size: 12px;
            text-align: center;
            margin: 5px 0;
            overflow: visible;
            position: relative;
            span {
                cursor: pointer;
                color: #2f54eb;
                &:hover {
                    color: #5b7dff;
                }
            }
        }
        .ques-text {
            text-align: center;
        }
        .baidu {
            background: #27c2ff;
            border: 0;
            cursor: pointer;
            &:hover {
                background: #5bd1ff;
            }
        }
        .download-btn {
            &.is-disabled {
                font-size: 20px;
            }
        }
        .pay-btn {
            background-color: #2f54eb;
            border-color: #2f54eb;
            &:hover {
                background: #6583ff;
                border-color: #6583ff;
            }
            &.disabled {
                background-color: #d0d0d0;
                border-color: #bababa;
                cursor: inherit;
                &:hover {
                    background: #d0d0d0;
                }
            }
        }
        .download-tip {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            color: #aaa;
            font-size: 12px;
            /deep/ .el-icon-warning-outline {
                margin-left: 5px;
                transform: rotateX(180deg);
                font-size: 14px;
            }
        }
        .bottom-info {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            margin-top: 20px;
        }
        .authorized {
            .authorized-tit {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 20px 0;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
                font-size: 14px;
                position: relative;
                .authorized-active {
                    cursor: pointer;
                    color: #2c54ef;
                    &:hover {
                        color: #5b7dff;
                    }
                }
                .authorized-active-default {
                    cursor: pointer;
                    color: #a8adc1;
                    margin-right: 15px;
                    &:nth-last-child(1) {
                        margin-right: 0;
                    }
                    &:hover {
                        color: #2f54eb;
                    }
                }
            }
            .authorized-item {
                border-radius: 2px 2px 2px 2px;
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                padding: 15px;
                font-weight: 400;
                color: #555555;
                line-height: 20px;
                font-size: 14px;
                overflow: hidden;
                &:nth-child(even) {
                    background: #fafafa;
                }
                .authorized-item-text {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 8px;
                    position: relative;
                    top: 3px;
                }
            }
        }
        .service-modal {
            position: absolute;
            left: -100px;
            cursor: default;
            top: 30px;
            width: 470px;
            height: 180px;
            background: #fff;
            box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.302);
            border-radius: 4px 4px 4px 4px;
            padding: 15px 20px;
            overflow: hidden;
            display: flex;
            z-index: 100;
            img {
                width: 150px;
                height: 150px;
                border-radius: 2px;
                margin-right: 15px;
            }
            & > div {
                flex: 1;
                height: 150px;
                margin-top: 3px;
            }
            &-tit {
                color: #252525;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                margin-bottom: 12px;
            }
            &-info {
                color: #8c8c8c;
                font-size: 18px;
                line-height: 26px;
                white-space: normal;
                text-align: left;
            }
        }
    }
    .bottom-tit {
        font-size: 18px;
        font-weight: 600;
        color: #272c40;
        line-height: 26px;
        margin-top: 20px;
    }
    .image-list {
        &-item {
            display: inline-block;
            margin-right: 20px;
            margin-top: 20px;
            width: 300px;
        }
    }
}
.pay-modal {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .pay-modal-con {
        background: #fff;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;
        .modal-tit {
            font-weight: 400;
            font-size: 20px;
            color: #272c40;
            margin: 20px 0 15px 0;
            text-align: center;
        }
        .modal-close {
            position: absolute;
            right: -60px;
            top: -25px;
            width: 50px;
            height: 50px;
            cursor: pointer;
        }
        .pay-con {
            padding: 0 59px 50px 59px;
            display: flex;
            .pay-icon {
                width: 130px;
                height: 115px;
                background: #f7fff7;
                border-radius: 6px 6px 6px 6px;
                border: 1px solid #09bb07;
                margin-right: 24px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                cursor: pointer;
                &:hover {
                    background: #deffde;
                }
                &.alipay {
                    background: #f7faff;
                    border-color: #1677ff;
                    &:hover {
                        background: #e3edff;
                    }
                }
                &.common {
                    background: #fff7f7;
                    border-color: #fa5151;
                    &:hover {
                        background: #ffe0e0;
                    }
                }
                img {
                    width: 43px;
                    margin-bottom: 16px;
                }
                &:nth-last-child(1) {
                    margin-right: 0;
                }
            }
        }
        .pay-qr {
            box-sizing: content-box;
            width: 200px;
            padding: 0 50px 30px 50px;
            img {
                width: 200px;
            }
        }
    }
}
.ques {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 20px 20px 20px;
    border-radius: 4px;
    img {
        float: left;
        margin-right: 10px;
        width: 60px;
    }
    &-tip {
        color: #666;
    }
    &-text {
        font-size: 12px;
        color: #999;
    }
    &-desc {
        flex: 1;
    }
}
.ques-other {
    margin-top: 10px;
    border-radius: 4px;
    padding: 20px;
}
.share {
    color: #758ef7;

    &-img {
        margin-right: 5px;
        vertical-align: top;
    }
}
.collected-con {
    color: #ed709b;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.collect-con {
    color: #999;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.icon-collect-btn {
    color: #999;
    cursor: pointer;
}
.collected {
    color: #ed709b;
    padding: 6px;
    cursor: pointer;
}
</style>
